/**
 * Компоненты Context Debt.
 *
 * KNOWLEDGE_CONCENTRATION — честное имя бывшего Handoff Debt: считается по
 * концентрации авторства, а не по содержимому голов.
 * DECISION_DEBT — узкое наблюдаемое подмножество: решения, упомянутые в
 * Jira/Confluence без связанной decision record.
 */
export var ContextAuditComponent;
(function (ContextAuditComponent) {
    ContextAuditComponent["TASK_DEBT"] = "task_debt";
    ContextAuditComponent["DOCUMENTATION_DEBT"] = "documentation_debt";
    /** Изменения в коде, которые нельзя связать с задачей. */
    ContextAuditComponent["TRACEABILITY_DEBT"] = "traceability_debt";
    ContextAuditComponent["DECISION_DEBT"] = "decision_debt";
    ContextAuditComponent["MEETING_DEBT"] = "meeting_debt";
    ContextAuditComponent["KNOWLEDGE_CONCENTRATION"] = "knowledge_concentration";
})(ContextAuditComponent || (ContextAuditComponent = {}));
//# sourceMappingURL=context-audit-component.enum.js.map